import React from 'react';
import ReactDOM from 'react-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'toastr/build/toastr.min.css';
import './styles.css';
import App from './App';

ReactDOM.render(<App />, document.getElementById('root'));
